import React from "react";
import { useState } from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import Home from "./Home";

function Main() {
  const [openSidebarToggle, setOpenSidebarToggle] = useState(false);
  const pageName = "Dashboard";
  const OpenSidebar = () => {
    setOpenSidebarToggle(!openSidebarToggle);
  };
  return (
    <>
      <div className="grid-container">
        <Header OpenSidebar={OpenSidebar} pageName={pageName} />
        <Sidebar  
          openSidebarToggle={openSidebarToggle}
          OpenSidebar={OpenSidebar}
        />
        <Home />
      </div>
    </>
  );
}

export default Main;
